import React from 'react';
import { Route, Switch } from 'react-router-dom';

import PicksheetUpload from '../../../Picking/PicksheetUpload/index';
import PrintPickingSheetForm from '../../../Picking/PrintPickingSheet/index';
import PickingConfirmationForm from '../../../Picking/PickingConfirmation/index';
import TesterConfirmationForm from '../../../Picking/TesterConfirmation/index';
import DipatchConfirmationUploadForm from '../../../Picking/DispatchConfirmation/index';
import PrintPickingDetailForm from '../../../Picking/PrintDetail/index';
import PrintPickingDetail from '../../../Picking/PrintPickingDetail/index';
import PickingCancellationForm from '../../../Picking/PickingCancellation/index';
import PickingTracking from '../../../Picking/PickingTracking/index';
import PickingPrioritization from '../../../Picking/PickingPrioritization/index';


export default () => (
  <Switch>
    <Route path="/picking/picksheet_upload" component={PicksheetUpload} />
    <Route path="/picking/printPickingSheet" component={PrintPickingSheetForm} />
    <Route path="/picking/pickingConfirmation" component={PickingConfirmationForm} />
    <Route path="/picking/testerConfirmation" component={TesterConfirmationForm} />
    <Route path="/picking/printPickingDetail" component={PrintPickingDetailForm} />
    <Route path="/picking/printPickingDetail1" component={PrintPickingDetail} />
    <Route path="/picking/dispatchConfirmation" component={DipatchConfirmationUploadForm} />
    <Route path="/picking/pickingCancellation" component={PickingCancellationForm} />
    <Route path="/picking/pickingTracking" component={PickingTracking} />
     <Route path="/picking/pickingPrioritization" component={PickingPrioritization} />

    
  </Switch>
);
